/*
 * InfoHelper
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { palette } from 'styled-theme';
// $FlowIssue
import { FormattedMessage } from 'react-intl';

// $FlowIssue
import { ReactComponent as IconInfo } from '@/icons/ic-info.svg';

import messages from './messages';

export type InfoHelperProps = {
  palette?: string,
  message?: React$Node,
  icon?: React$Node,
};

const InfoHelperWrapper = styled.div.attrs(() => ({
  testid: 'info-helper',
}))`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: rgba(62, 76, 89, 0.7);

  & > svg {
    color: ${palette(1)};
    margin-right: 9px;
  }
`;

/**
 * InfoHelper React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {React$Node} [props.children] - childs
 * @param {string} [props.message] - message
 * @param {React$Node} [props.icon] - info icon
 * @example <caption>Simple usage</caption>
 * <InfoHelper message="title" />
 * @returns {React$Node} React-component
 */
export const InfoHelper = ({ icon, message, ...rest }: InfoHelperProps) => (
  <InfoHelperWrapper {...rest} testid="info-helper">
    {icon || <IconInfo />}
    {message || <FormattedMessage {...messages.title} />}
  </InfoHelperWrapper>
);

InfoHelper.defaultProps = {
  palette: 'primary',
  testid: 'gag',
};
